import React from 'react';
import PropTypes from 'prop-types';
import { List, ListItem, ListItemText, FormGroup, Typography } from '@material-ui/core';
import cx from 'classnames';
import { Arrow, CheckIcon } from 'sharedComponents/Icons';
import { STORE_MANAGER_LIST } from 'constants';
import Drawer from '../Drawer';

const StoreSelection = ({ classes, setSelectedStore, selectedStore, brand, headerMode, selectedStoreId }) => {
  const [drawer, setDrawer] = React.useState(null);

  const onUpdateClick = ([storeId, storeName]) => {
    setSelectedStore({
      brand,
      storeId,
      storeName,
    });
    setDrawer(null);
  };

  const storeList = React.useMemo(() => Object.values(STORE_MANAGER_LIST).filter((store) => store.brand === brand), [
    brand,
  ]);

  const onClose = () => {
    setDrawer(null);
  };

  const openStoreDrawer = () => {
    setDrawer({
      content: (
        <FormGroup>
          <List className={classes.storesList} data-testid="store-selection-list">
            {storeList.map(({ storeId, storeName }) => (
              <ListItem
                className={classes.filterItem}
                key={storeId}
                onClick={() => onUpdateClick([storeId, storeName])}
                data-testid={`store-selection-${storeId}-btn`}
              >
                <ListItemText primary={`${storeId} ${storeName}`} classes={classes.menuText} />
                {storeId === selectedStoreId && <CheckIcon className={classes.checkIcon} />}
              </ListItem>
            ))}
          </List>
        </FormGroup>
      ),
    });
  };

  return (
    <>
      <Typography
        className={cx(headerMode ? classes.faceWidgetInHeader : classes.faceWidget)}
        variant="body1"
        color="textSecondary"
        onClick={openStoreDrawer}
      >
        {selectedStore.storeName} <Arrow className={classes.chevronIconDown} />
      </Typography>
      <Drawer title="SELECT STORE" open={!!drawer} onClose={onClose}>
        {drawer && drawer.content}
      </Drawer>
    </>
  );
};

StoreSelection.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  setSelectedStore: PropTypes.func,
  selectedStore: PropTypes.objectOf(PropTypes.string),
  brand: PropTypes.string,
  headerMode: PropTypes.bool,
  selectedStoreId: PropTypes.string,
};

StoreSelection.defaultProps = {
  classes: {},
  setSelectedStore: () => {},
  selectedStore: {},
};

export default StoreSelection;
